import { inject } from '@angular/core';

import { SportsProductService } from '@frontend/sports/host-app/sports-product/feature/sports-product-service';

import { SportsWebLazyBootstrapService } from './bootstrap/sports-web-lazy-bootstrap.service';

/**
 * Route guard for initializing Sports-Web bootstrap services in Host-App.
 * This guard takes care of running OnAppInit services which are specific to Sports-Web since those will not be run by Host-App.
 */
export const sportsWebProductActivateGuard = () => {
    inject(SportsProductService).activateSports();

    return inject(SportsWebLazyBootstrapService).onSportsWebInit();
};

export const sportsWebProductDeactivateGuard = () => {
    inject(SportsProductService).deactivateSports();
};
